import React, { Component, Fragment } from "react";
import Scheduler, { SchedulerData, ViewTypes } from "react-big-scheduler";
import WithDragDropContext from "./withDnDContext";
import "./scheduleMed.css";
import axios from "axios";
import { Col, Row } from "react-bootstrap";
import { Redirect } from "react-router";
import "react-big-scheduler/lib/css/style.css";
import "moment/locale/en-gb";
import { currentCareSiteId } from "../../../redux-toolkit/reducer/switchSites";
import {
  convertToTimeZone,
  getFullName,
  handleDataPrint,
  sortByLatestDateFirst,
} from "../../../utils/CommonFunctions";
import { AiFillPrinter } from "react-icons/ai";
import JsonDownload from "../../../components/DownloadExcel/DownloadExcel";
const moment = require("moment-timezone");

const chatUserImg = "/admin/images/chatUser.svg";

const taskStatusColorData = {
  assigned: {
    status: "Assigned",
    bgColor: "#828282",
  },
  omitted: {
    status: "Omitted",
    bgColor: "#F2C94C",
  },
  overdue: {
    status: "Overdue",
    bgColor: "#eb5757",
  },
  true: {
    status: "Completed",
    bgColor: "#219653",
  },
  prn: {
    status: "PRN",
    bgColor: "#2fbbe9",
  },
};

class Basic extends Component {
  constructor(props) {
    super(props);
    const pageHeight = window.innerHeight - 350;
    //let schedulerData = new SchedulerData(new moment("2017-12-18").format(DATE_FORMAT), ViewTypes.Week);
    this.schedulerData = new SchedulerData(
      new Date(),
      ViewTypes.Week,
      false,
      false,
      {
        schedulerWidth: "88%",
        besidesWidth: 0,
        defaultEventBgColor: "#808080",
        resourceName: "Name",
        movable: true,
        creatable: true,
        crossResourceMove: false,
        eventItemPopoverEnabled: true,
        calendarPopoverEnabled: true,
        dayResourceTableWidth: 180,
        weekResourceTableWidth: 180,
        eventItemHeight: 35,
        eventItemLineHeight: 40,
        // schedulerMaxHeight: 380,
        schedulerMaxHeight: pageHeight,
        selectedAreaColor: "#808080",
        recurringEventsEnabled: true,
        headerEnabled: true,
        displayWeekend: true,
        nonWorkingTimeHeadColor: "grey",
        nonWorkingTimeHeadBgColor: "white",
        nonWorkingTimeBodyBgColor: "white",
        groupOnlySlotColor: "#808080.",
        startResizable: true,
        customCellWidth: 80,
        dayCellWidth: "5%",
        endResizable: true,
        weekCellWidth: "12%",
        views: [
          {
            viewName: "Day",
            viewType: ViewTypes.Day,
            showAgenda: false,
            isEventPerspective: false,
          },
          {
            viewName: "Week",
            viewType: ViewTypes.Week,
            showAgenda: false,
            isEventPerspective: false,
          },
          {
            viewName: "Month",
            viewType: ViewTypes.Month,
            showAgenda: false,
            isEventPerspective: false,
          },
        ],
      }
    );

    this.schedulerData.localeMoment.locale("en-gb");

    this.state = {
      viewModel: this.schedulerData,
      isDisplayed: false,
      redirect: false,
      clientId: "",
      clientSide: false,
      EventsArr: [],
      resourceArr: [],
      dataToDownload: [],
      isviewdisabled: false,
      loader: true,
      medicCountStatus: null,
      SchedulerAccess: props.SchedulerAccess,
      intervalId: "",
    };
  }

  componentDidMount() {
    const intervalId = setInterval(() => {
      this.getMedicinesCarehomeWise();
    }, 25000);
    this.getMedicinesCarehomeWise();
    this.setState(() => ({ intervalId: intervalId }));
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  getMedicinesCarehomeWise = () => {
    const start = this.state.viewModel.startDate;
    const end = this.state.viewModel.endDate;
    axios({
      url: `${process.env.REACT_APP_BASEURL}/getMedicinesCarehomeWiseNew?careHomeId=${currentCareSiteId}&startDate=${start}&endDate=${end}`,
      method: "GET",
      headers: { Authorization: localStorage.getItem("care_admin_token") },
    })
      .then((res) => {
        const resourceArr = [];
        let eventsArr = [];
        const downloadData = [];

        let countData = res?.data?.data;
        const clientScheduleData = res?.data?.data?.data;

        if (clientScheduleData) {
          // console.log(clientScheduleData, "clientScheduleData");
          clientScheduleData?.forEach((client) => {
            const id = client?._id;
            const name = getFullName(client);
            const image = client.image ?? chatUserImg;
            resourceArr.push({ id: id, name, image });
            const medSchedule = client?.medicineSchedule;
            // console.log(medSchedule, "medSchedule---");
            const clientEvents = [];

            medSchedule?.medicineTasks?.forEach((mTask) => {
              const globalTask = mTask.globalTask;
              let tStatus = mTask.status;
              if (globalTask?.prn === "Yes") {
                tStatus = "prn";
              } else if (
                ["false", "assigned", "in-process"].includes(
                  mTask.status?.toLowerCase()
                )
              ) {
                tStatus = "assigned";
              }
              const taskStatusObj = taskStatusColorData[tStatus];
              if (taskStatusObj) {
                console.log(mTask, "mTask-----");
                clientEvents.push({
                  shiftId: mTask._id,
                  ShiftData: mTask,
                  shiftDate: mTask?.shiftDate,
                  editShiftId: mTask._id,
                  evdata: name ? name : "",
                  status: taskStatusObj?.status,
                  evImage: image,
                  id: `${taskStatusObj?.status}${mTask._id}`,
                  start: mTask?.startDateTime ?? "",
                  taskList: mTask ?? [],
                  end: mTask?.endDateTime ?? "",
                  schedule: mTask?.schedule?.[0],
                  resourceId: id,
                  title: globalTask ? globalTask?.medName?.split("(")[0] : "",
                  bgColor: taskStatusObj?.bgColor,
                  globalTaskId: mTask?.globalTaskId,
                  tStatus,
                });
              }
            });

            const notMatchedEvents = this.generateDailyTasks(
              medSchedule?.notMatchedMedicines
            );

            // console.log(clientEvents, "clientEvents", name);

            notMatchedEvents?.forEach((mTask, mIndex) => {
              let bgColor = "#f2994a";
              let taskStatus = "notMatched";

              if (mTask.prn === "Yes") {
                bgColor = "#2fbbe9";
                taskStatus = "prn";
              }

              mTask?.schedule?.forEach((schedule) => {
                const isEventAdded = clientEvents.some(
                  (eItem) =>
                    eItem.globalTaskId === mTask?._id &&
                    eItem.shiftDate?.includes(mTask.date) &&
                    eItem.schedule === schedule
                );
                if (!isEventAdded) {
                  eventsArr.push({
                    shiftId: mTask._id,
                    ShiftData: mTask,
                    editShiftId: mTask._id,
                    evdata: name ? name : "",
                    status: mTask.prn === "Yes" ? "PRN" : "not matched",
                    evImage: image,
                    schedule: schedule,
                    id: `${mIndex}notMatched${mTask?._id}${schedule}`,
                    start: `${mTask?.date?.split("T")[0]} ${
                      schedule ? schedule?.split("-")[0] : "00:00"
                    }`,
                    taskList: mTask,
                    end: `${mTask?.date?.split("T")[0]} ${
                      schedule ? schedule?.split("-")[1] : "00:30"
                    }`,
                    date: mTask?.date?.split("T")[0],
                    resourceId: id,
                    title: mTask.medName?.split("(")[0],
                    bgColor: bgColor,
                    tStatus: taskStatus,
                  });
                }
              });
            });
            eventsArr.push(...clientEvents);
          });
        }

        eventsArr?.forEach((elem) => {
          downloadData.push({
            client: elem.evdata,
            ["Med Name"]: elem.title,
            ["Start Time"]: elem.start,
            ["End Time"]: elem.end,
            CareTeam: elem?.ShiftData?.shiftData?.careTeamMember ?? "",
            ["Status"]: elem.status,
          });
        });

        // console.log(eventsArr, "eventsArr");
        const noShiftCount = this.countTaskByTimeStatus(
          eventsArr,
          "notMatched",
          start,
          end
        );
        const countToMinus =
          this.countTaskByStatus(eventsArr, "notMatched") - noShiftCount;
        let medicshiftCountStatus = {
          assignedTotal: this.countTaskByStatus(eventsArr, "assigned"),
          total: eventsArr?.length - countToMinus,
          noShift: noShiftCount,
          omittedTotal: this.countTaskByStatus(eventsArr, "omitted"),
          overdueTotal: this.countTaskByStatus(eventsArr, "overdue"),
          prnTotal: this.countTaskByStatus(eventsArr, "prn"),
          completed: this.countTaskByStatus(eventsArr, "true"),
        };
        this.schedulerData.setResources(resourceArr);
        this.schedulerData.setEvents(sortByLatestDateFirst(eventsArr, "start"));
        this.setState((prevState) => ({
          ...prevState,
          medicCountStatus: medicshiftCountStatus,
          EventsArr: sortByLatestDateFirst(eventsArr, "start"),
          resourceArr: resourceArr,
          dataToDownload: downloadData,
        }));
      })
      .catch((error) => console.log(`Error: ${error}`));
  };

  countTaskByTimeStatus(taskArr, tStatus, start, end) {
    const filterTaskArr = taskArr.filter(
      (item) =>
        new Date(item.date) >= new Date(start) &&
        new Date(item.date) <= new Date(end)
    );
    return filterTaskArr.reduce(
      (acc, curr) => acc + (curr.tStatus === tStatus ? 1 : 0),
      0
    );
  }

  countTaskByStatus(taskArr, tStatus) {
    return taskArr.reduce(
      (acc, curr) => acc + (curr.tStatus === tStatus ? 1 : 0),
      0
    );
  }

  generateDailyTasks(medicines) {
    const tasks = [];

    for (const med of medicines) {
      const start = new Date(med.startDate);
      const interval = this.getIntervalDays(med.frequency);
      const duration = +med.durationofCourse;

      for (let i = 0; i < duration; i += interval) {
        const taskDate = new Date(start);
        taskDate.setDate(start.getDate() + i);
        tasks.push({
          ...med,
          date: taskDate.toISOString().split("T")[0], // 'YYYY-MM-DD'
        });
      }
    }

    return tasks;
  }

  getIntervalDays(frequency) {
    switch (frequency) {
      case "Daily":
        return 1;
      case "Weekly":
        return 7;
      case "Monthly":
        return 30;
      default:
        return 1;
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.text !== this.props.text) {
      let filteredVal = this.state.resourceArr?.filter((elem) => {
        return elem.name.toLowerCase().includes(this.props.text.toLowerCase());
      });
      this.schedulerData.setResources(filteredVal);
      this.forceUpdate();
    }
  }

  toggleShowHide = (events, type) => {};

  toggle = () => {
    this.setState((state) => ({
      isDisplayed: !state.isDisplayed,
    }));
  };

  hide = () => {
    this.setState((state) => ({
      isDisplayed: !state.isDisplayed,
    }));
  };

  clear = () => {
    this.setState((state) => ({
      isDisplayed: !state.isDisplayed,
    }));
  };

  clientTem = () => {
    this.setState((state) => ({
      clientSide: !state.clientSide,
    }));
  };

  deleteShift(mainshiftId, shiftId, deleteType) {
    let data = JSON.stringify({
      mainshiftId: mainshiftId,
      shiftId: shiftId,
      type: deleteType,
    });

    let config = {
      method: "post",
      url: `${process.env.REACT_APP_BASEURL}/deleteshift`,
      headers: {
        Authorization: localStorage.getItem("care_admin_token"),
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        window.location.reload(false);
      })
      .catch(function (error) {});
  }

  render() {
    const { viewModel, redirect, clientId, medicCountStatus, dataToDownload } =
      this.state;

    if (redirect) {
      return (
        <Redirect
          to={{
            pathname: "/admin/clientweekschedule",
            state: { referrer: true, clientId: clientId },
          }}
        />
      );
    }
    return (
      <Fragment>
        <Row
          className="justify-content-center mt-4  gap-3 overViewWages_Responsive"
          style={{ transform: "translate(-50px, 0px)" }}
        >
          <Col
            xl={12}
            lg={12}
            md={12}
            className="d-flex justify-content-center  gap-4 overViewWages_Responsive"
          >
            <div className="sechudleCard" style={{ color: "#9e61e7" }}>
              <p className="mb-0">Total</p>
              <h5>{medicCountStatus?.total}</h5>
            </div>
            <div className="sechudleCard" style={{ color: "#F2994A" }}>
              <p className="mb-0">No Shift</p>
              <h5>{medicCountStatus?.noShift}</h5>
            </div>
            <div className="sechudleCard" style={{ color: "#828282" }}>
              <p className="mb-0">Assigned</p>
              <h5>{medicCountStatus?.assignedTotal}</h5>
            </div>
            <div className="sechudleCard" style={{ color: "#F2C94C" }}>
              <p className="mb-0">Omitted</p>
              <h5>{medicCountStatus?.omittedTotal}</h5>
            </div>
            <div className="sechudleCard" style={{ color: "#EB5757" }}>
              <p className="mb-0">Overdue</p>
              <h5>{medicCountStatus?.overdueTotal}</h5>
            </div>
            <div lg={3} className="sechudleCard" style={{ color: "#2FBBE9" }}>
              <p className="mb-0">PRNs Administered</p>
              <h5>{medicCountStatus?.prnTotal}</h5>
            </div>
            <div className="sechudleCard" style={{ color: "#219653" }}>
              <p className="mb-0">Completed</p>
              <h5>{medicCountStatus?.completed}</h5>
            </div>
          </Col>
        </Row>
        <div>
          <AiFillPrinter
            className="me-3 ms-1 curser_point"
            onClick={() => handleDataPrint(dataToDownload)}
          />
          <a className="curser_point">
            <JsonDownload
              fileName="payroll-excel"
              downloadfile={dataToDownload}
            />
          </a>
        </div>

        <div
          className="mt-2"
          style={{
            height: "calc(100vh - 325px)",
            minHeight: "250px",
            overflowY: "auto",
            overflowX: "hidden",
            width: "100%",
          }}
        >
          <Scheduler
            schedulerData={viewModel}
            prevClick={this.prevClick}
            nextClick={this.nextClick}
            onSelectDate={this.onSelectDate}
            onViewChange={this.onViewChange}
            eventItemClick={this.eventClicked}
            // updateEventStart={this.updateEventStart}
            // updateEventEnd={this.updateEventEnd}
            moveEvent={this.moveEvent}
            newEvent={this.newEvent}
            onScrollLeft={this.onScrollLeft}
            onScrollRight={this.onScrollRight}
            toggleExpandFunc={this.toggleExpandFunc}
            eventItemPopoverTemplateResolver={
              this.eventItemPopoverTemplateResolver
            }
            eventItemTemplateResolver={this.eventItemTemplateResolver}
            slotItemTemplateResolver={this.slotItemTemplateResolver}
            movingEvent={this.movingEvent}
          />
        </div>
      </Fragment>
    );
  }

  moveEvent = (schedulerData, event, slotId, slotName, start, end) => {
    if (!event.Shif) {
      return;
    }
    // console.log("moving event", event, slotName, slotId, start, start.split(" ")[0], end);
    let date = start.split(" ")[0];
    schedulerData.moveEvent(event, slotId, slotName, start, end);
    this.setState({
      viewModel: schedulerData,
    });

    var shiftType = [];
    var startTime = [];
    var endTime = [];
    var taskName = [];
    var taskType = [];
    event.ShiftData?.Task?.forEach((items, index) => {
      shiftType.push(items.shiftType);
      startTime.push(items.startTime);
      endTime.push(items.endTime);
      taskName.push(items.taskName);
      taskType.push(items.taskType);
    });

    if (shiftType.length > 1) {
      var type = "array";
    } else {
      var type = "string";
    }

    var data = new FormData();
    data.append("careHomeId", event.ShiftData.careHomeId);
    data.append("careTeamId", event?.ShiftData?.careTeamId._id);
    data.append("shiftId", event.ShiftData._id);
    data.append("clientId", event.ShiftData.clientId._id);
    data.append(
      "forClient",
      event.ShiftData.forClient
        .split(" ")
        .filter((s) => s)
        .join(" ")
    );
    data.append(
      "careTeamMember",
      event.ShiftData.careTeamMember
        .split(" ")
        .filter((s) => s)
        .join(" ")
    );
    data.append("Date", date);
    data.append("startingTime", event.ShiftData.startingTime);
    data.append("endingTime", event.ShiftData.endingTime);
    data.append("recurringTask", event.ShiftData.recurringTask);
    data.append("recurringTasktype", event.ShiftData.recurringTasktype);
    data.append("instruction", event.ShiftData.instruction);
    data.append("recurringShiftType", event.ShiftData.recurringShiftType);
    data.append(
      "attachments",
      event.ShiftData.image ? event.ShiftData.image : ""
    );
    data.append("type", type);
    data.append("endDate", event.ShiftData.endDate);
    data.append("shiftType", shiftType);
    data.append("startTime", startTime);
    data.append("endTime", endTime);
    data.append("taskName", taskName);
    data.append("taskType", taskType);

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BASEURL}/editShift`,
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        // window.location.reload(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  eventItemPopoverTemplateResolver = (
    schedulerData,
    eventItem,
    title,
    start,
    end,
    statusColor
  ) => {
    console.log(eventItem, "eventItem");
    const mTask = eventItem.taskList;
    const globalTask = eventItem.taskList?.globalTask ?? mTask;
    let schedule =
      eventItem?.schedule ?? `${mTask?.startTime}-${mTask?.endTime}`;
    // const userData = JSON.parse(localStorage.getItem("userData"));
    return (
      <div style={{ width: "300px", height: "220px" }}>
        <div className="scheduler_dot">
          <span
            className="status-dot mt-1 col-1"
            style={{ backgroundColor: eventItem?.bgColor ?? "#898988" }}
          ></span>
          <span className="header2-text ms-1 text-center" title="Medicine Name">
            {globalTask?.medName}
          </span>
        </div>
        <Row type="flex" align="middle">
          <Col span={100} style={{ lineHeight: "12px" }}>
            <p>
              Dose Amount: {globalTask?.doseAmount}{" "}
              {eventItem.taskList?.strengthUnit}, Dose Route:{" "}
              {globalTask?.adminRoute}
            </p>
            {globalTask?.prn === "No" && (
              <p>Duration of Course: {globalTask?.durationofCourse} Days</p>
            )}
            {globalTask?.prn === "No" && <p>Schedule Time: {schedule}</p>}
            <p>Meal Consideration: {globalTask?.mealConsideration}</p>
            {/* <p>Units (in-Stock): {eventItem.taskList?.units}</p> */}
            {(eventItem.bgColor === "#2fbbe9" ||
              eventItem.bgColor === "#219653") && (
              <p>Completed Time: {convertToTimeZone(mTask?.timestamp)}</p>
            )}
            {eventItem.bgColor === "#F2C94C" && (
              <p>Omitted Time: {convertToTimeZone(mTask?.timestamp)}</p>
            )}
            {(eventItem.bgColor === "#F2C94C" ||
              eventItem.bgColor === "#2fbbe9" ||
              eventItem.bgColor === "#219653") && (
              <p>CareTeam: {getFullName(mTask?.doneBy)}</p>
            )}
          </Col>
        </Row>
      </div>
    );
  };

  deleteButtonClicked = (event) => {
    this.setState(
      (prevState) => {
        return prevState.viewModel.events.filter(
          (index) => index.id !== event.id
        );
      },
      () => this.state.viewModel
    );
    this.deleteShift(event.id);
  };

  slotItemTemplateResolver(
    schedulerData,
    slot,
    slotClickedFunc,
    width,
    clsName
  ) {
    let resourceData = schedulerData.getSlotById(slot.slotId);
    return (
      <span className="schedulerResourse">
        <img className="profile_img_calendar" src={`${resourceData?.image}`} />{" "}
        <span>{slot.slotName}</span>
      </span>
    );
  }

  prevClick = (schedulerData) => {
    schedulerData.prev();
    schedulerData.setEvents(this.state.EventsArr);
    this.setState({
      viewModel: schedulerData,
    });
    this.getMedicinesCarehomeWise(
      schedulerData.startDate,
      schedulerData.endDate
    );
  };

  nextClick = (schedulerData) => {
    schedulerData.next();
    schedulerData.setEvents(this.state.EventsArr);
    this.setState({
      viewModel: schedulerData,
    });
    this.getMedicinesCarehomeWise(
      schedulerData.startDate,
      schedulerData.endDate
    );
  };

  onViewChange = (schedulerData, view) => {
    schedulerData.setViewType(
      view.viewType,
      view.showAgenda,
      view.isEventPerspective
    );
    schedulerData.setEvents(this.state.EventsArr);
    this.setState({
      viewModel: schedulerData,
    });
    this.getMedicinesCarehomeWise(
      schedulerData.startDate,
      schedulerData.endDate
    );
  };

  onSelectDate = (schedulerData, date) => {
    schedulerData.setDate(date);
    schedulerData.setEvents(this.state.EventsArr);
    this.setState({
      viewModel: schedulerData,
    });
    this.getMedicinesCarehomeWise(
      schedulerData.startDate,
      schedulerData.endDate
    );
  };

  eventClicked = (schedulerData, event) => {
    schedulerData.setEvents(this.state.EventsArr);
    this.setState({
      viewModel: schedulerData,
    });
  };

  newEvent = (schedulerData, slotId, slotName, start, end, type, item) => {
    // console.log(schedulerData, slotId, slotName, start, end, type, item, "eventClicked==>>newEvent")
    this.setState({ redirect: false, clientId: slotId });
  };

  updateEventStart = (schedulerData, event, newStart) => {
    schedulerData.updateEventStart(event, newStart);
    this.setState({
      viewModel: schedulerData,
    });
  };

  updateEventEnd = (schedulerData, event, newEnd) => {
    schedulerData.updateEventEnd(event, newEnd);
    this.setState({
      viewModel: schedulerData,
    });
  };

  onScrollRight = (schedulerData, schedulerContent, maxScrollLeft) => {
    if (schedulerData.ViewTypes === ViewTypes.Day) {
      schedulerData.next();
      schedulerData.setEvents(this.state.EventsArr);
      this.setState({
        viewModel: schedulerData,
      });
      schedulerContent.scrollLeft = maxScrollLeft - 10;
    }
  };

  onScrollLeft = (schedulerData, schedulerContent, maxScrollLeft) => {
    if (schedulerData.ViewTypes === ViewTypes.Day) {
      schedulerData.prev();
      schedulerData.setEvents(this.state.EventsArr);
      this.setState({
        viewModel: schedulerData,
      });
      schedulerContent.scrollLeft = 10;
    }
  };

  toggleExpandFunc = (schedulerData, slotId) => {
    schedulerData.toggleExpandStatus(slotId);
    this.setState({ viewModel: schedulerData });
  };
}

export default WithDragDropContext(Basic);
